import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { QFieldValueLib } from "./QFieldValueLib";
import { QXMLObject } from "./QXMLObject";

export class QObjRefLib extends QXMLObject {
  constructor() {
    super();
    this.fFieldLibList = null;
    this.fFieldIDList = null;
    this.fClass = null;
  }

  InitRefLib(theClass) {
    this.fClass = theClass;
    this.fFieldLibList = [];
    this.fFieldIDList = [];
    this.SetXMLElementName("qreflib");
  }

  AddRefValue(fieldID, fieldValue) {
    var f = this.fFieldLibList;
    var n = f.length;

    for (var i = 0; i < n; i++) {
      var fvl = f[i];
      if (fieldID == fvl.GetFieldID()) {
        fvl.AddRefValue(fieldValue);
        return;
      }
    }

    var newFVL = new QFieldValueLib();
    newFVL.InitFieldValueLib(fieldID);
    this.fFieldLibList.push(newFVL);
    this.fFieldIDList.push(fieldID);

    newFVL.AddRefValue(fieldValue);
  }

  OutputToJSON() {
    var refLib = {};
    refLib["fieldList"] = [];
    var f = this.fFieldLibList;
    var n = f.length;

    for (var i = 0; i < n; i++) {
      var fvl = f[i];
      refLib["fieldList"].push(fvl.OutputToJSON());
    }
    return refLib;
  }

  LoadFromJSON(json) {
    var fieldList = json["fieldList"];

    for (var i = 0; i < fieldList.length; i++) {
      var objData = fieldList[i];
      var fvl = new QFieldValueLib();
      fvl.InitFieldValueLib(null);
      fvl.LoadFromJSON(objData);
      this.fFieldLibList.push(fvl);

      var fieldID = fvl.GetFieldID();
      var fieldDef = this.fClass.GetFieldDefByID(fieldID);
      if (fieldDef) {
        fieldDef.SetCompressed(true); // DONOTCOMPRESS
        fieldDef["lookup"] = fvl;
      }
    }
  }

  GetReference(fieldID, fieldValue) {
    var f = this.fFieldLibList;
    //  var n = f.length;

    var idx = this.fFieldIDList.indexOf(fieldID);
    if (idx == -1) return null;

    var entry = f[idx];
    var a = entry.GetRefValue(fieldValue);
    return a;

    /*
	var a = fvl.GetRefValue(fieldValue);

    for (var i=0;i<n;i++)
    {
        var fvl = f[i];
        if (fieldID == fvl.GetFieldID())
        {
             var a = fvl.GetRefValue(fieldValue);
             return a;
        }
    }

    return null;
    */
  }

  StripDups(fieldValueLib) {
    return fieldValueLib.CullValueList();
  }

  CullRefTable(fieldDef, includeCount) {
    var f = this.fFieldLibList;
    var n = f.length;
    var fieldID = fieldDef.GetFieldID();

    for (var i = 0; i < n; i++) {
      var fvl = f[i];
      if (fieldID == fvl.GetFieldID()) {
        var maxSize = this.StripDups(fvl);
        var vCount = fvl.ValueCount();
        var canCompress = maxSize > 1;

        if (canCompress) {
          if (includeCount > 100) canCompress = vCount < includeCount * 0.8;
          else canCompress = vCount < includeCount;
        }
        //   console.log("CullRefTable - fieldID:", fieldID, " vCount:", vCount, " includeCount:",includeCount);
        //   fieldDef.SetCompressed(false); // canCompress); DONOTCOMPRESS
        fieldDef.SetCompressed(canCompress);
        if (canCompress == false) {
          this.fFieldLibList.splice(i, 1);
          this.fFieldIDList.splice(i, 1);
        }
        return;
      }
    }

    fieldDef.SetCompressed(false);
  }

  OutputChildElements(stream) {
    var f = this.fFieldLibList;
    var n = f.length;

    for (var i = 0; i < n; i++) {
      var fvl = f[i];
      fvl.OutputToXML(stream);
    }
  }

  LoadChildElements(objTree) {
    var childList = objTree.GetChildOfTypeList("fieldvallib");
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var objData = childList[i];
      var fvl = new QFieldValueLib();
      fvl.InitFieldValueLib(null);
      fvl.LoadFromXML(objData);
      this.fFieldLibList.push(fvl);

      var fieldID = fvl.GetFieldID();
      var fieldDef = this.fClass.GetFieldDefByID(fieldID);
      fieldDef.SetCompressed(true); // DONOTCOMPRESS
      fieldDef["lookup"] = fvl;
    }
  }
}
